import { Layout } from "antd";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { SideMenu } from "../../shared/components/SideMenu";
import { MainHeader } from "../../shared/components/MainHeader";
import { SyncUser } from "../../auth/components/SyncUser";
import { PageContainer } from "../../shared/components/PageContainer";
import { SmallContainer } from "../../shared/components/SmallContainer";
const { Content } = Layout;

export const SignalProviderLayout = () => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Layout hasSider>
      <SyncUser />
      <SideMenu 
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
      <Layout style={ collapsed ? { marginLeft: 80 } : { marginLeft: 250 } }>
        <MainHeader
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />
        <Content>
          <SmallContainer>
            <div style={{ margin: '1rem 0' }}>
              <Outlet />
            </div>
          </SmallContainer>
        </Content>
      </Layout>
    </Layout>
  );
};
